import { saveSearch } from "../SaveSearch/SaveSearch"
import firebase from 'firebase/app';


export const generatedOutreachAdd = async(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts) =>{

    var messagesRef = firebase
    .firestore()
    .collection('organizations')
    .doc(fbProfile.company)
    .collection('prospects')
    .doc(docId)

    messagesRef.update({
        ContentCreated: firebase.firestore.FieldValue.arrayUnion({
            ProspectName: profile?.full_name ? profile?.full_name : profile.ProspectName,
            ProspectContent: output,
            ProspectValuePropUsed: vProp,
            ProspectInterestUsed: intVal,
            ProspectMessageType: type,
            CreatedAt: new Date(),
        })
    }).then(() =>{
        saveSearch(fbProfile, auth, profile, url, sendArr, output, foundInts, docId)
        setGenerating(false)
    })
}

export const generatedOutreachAddOnBoard = async(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts) =>{

    var messagesRef = firebase
    .firestore()
    .collection('organizations')
    .doc(fbProfile.company)
    .collection('prospects')
    .doc('onboarding')

    messagesRef.set({
            ProspectContent: output,
            ProspectValuePropUsed: vProp,
            ProspectInterestUsed: intVal,
            ProspectMessageType: type,
            createdAt: new Date(),
    }).then(() =>{
        // saveSearch(fbProfile, auth, profile, url, sendArr, output, foundInts, docId)
        setGenerating(false)
    })
}